import { metaSetter } from '@app/utils/meta-setter'
import { GuidesLayout } from '@app/components/guide-layout'
import { Article } from '@app/components/templates/article'
import { featuredItems } from '@app/data/guides/posts'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/guides/crawl-limit-pages',
    }),
  }
}

function CrawlLimitPages({ translation }: { translation: string }) {
  return (
    <Article
      translation={translation}
      parentRoute={'guides'}
      featuredItems={featuredItems}
      category='crawling'
      index={1}
    />
  )
}

CrawlLimitPages.getLayout = GuidesLayout

export default metaSetter(
  { CrawlLimitPages },
  {
    translation: 'crawl-limit-pages',
  }
)
